import clonedeep from 'lodash/cloneDeep';

import { getRootReducer } from 'src/common/utils/getRootReducer';

export const appReducer = getRootReducer();

const initialState = appReducer(undefined, {
  type: '',
});

// return default initial state
export const createInitialState = () => clonedeep(initialState);
